import { Flex } from "@mantine/core";
import { useRef } from "react";

import { Loader } from "../../../components/Loader.tsx";
import SectionTitle from "../../../components/Section/SectionTitle/SectionTitle.tsx";
import { Customer } from "../../../types/customer.ts";
import GiroManagementTable from "./GiroManagement/GiroManagementTable.tsx";
import LegalDocumentTable from "./LegalDocumentTable/LegalDocumentTable.tsx";
import {
  LimitRequestsTable,
  LimitRequestsTableHandle,
} from "./LimitRequestsTable/LimitRequestsTable.tsx";
import LimitTable from "./LimitTable/LimitTable.tsx";

interface Props {
  company: Pick<Customer, "id" | "partnerCode"> | null | undefined;
}

export default function LimitInfo({ company }: Props) {
  const limitRequestsTableRef = useRef<LimitRequestsTableHandle>(null);

  if (!company) {
    return <Loader />;
  }

  return (
    <Flex direction="column" gap={{ base: 16, sm: 24 }}>
      <LimitTable
        companyId={company?.id}
        refreshLimitRequests={() => {
          limitRequestsTableRef.current?.refresh();
        }}
      />
      <LimitRequestsTable companyId={company?.id} ref={limitRequestsTableRef} />
      <LegalDocumentTable customerId={company?.id} />
      <Flex direction="column" gap={16}>
        <SectionTitle variant="blue">GIRO Management</SectionTitle>
        <GiroManagementTable company={company} />
      </Flex>
    </Flex>
  );
}
